/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2026 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import React from 'react'
import ProcessNotification from '../ProcessNotification'
import { changeShowStatusById } from '@/services/processes'
import { useAuth0 } from '@auth0/auth0-react'
import {
  batchLabelByProcessType,
  getStatus,
  labelByProcessType,
  processedLabelByProcessType,
  urlsByProcessType
} from './handlers'

const ProgressBar = ({
  processNotifications,
  setProcessNotifications,
  updateNotifications
}) => {
  const { getAccessTokenSilently: getAccessToken } = useAuth0()
  const processing = processNotifications?.map(process => {
    const viewItemLabel = labelByProcessType[process.type]
    const batchLabel = batchLabelByProcessType[process.type]
    const processedLabel = processedLabelByProcessType[process.type]
    const itemUrl = urlsByProcessType[process.type] && process.relatedId &&
      `${urlsByProcessType[process.type]}/${process.relatedId}`
    const removeNotification = async () => {
      const currentNotifications = processNotifications.filter(
        obj => obj.id !== process.id
      )

      await changeShowStatusById(
        { id: process.id, data: { showStatus: false } },
        getAccessToken
      )
      updateNotifications(currentNotifications)
      setProcessNotifications(currentNotifications)
    }
    const status = getStatus(process.status)
    return <ProcessNotification
      currentCount={process.currentCount}
      description={process.description}
      failedCount={process.failedCount}
      isParallelProcess={process.isParallelProcess}
      itemLabel={batchLabel}
      itemName={process.taskNameTitle}
      itemUrl={itemUrl}
      key={process.id}
      onClose={removeNotification}
      processedLabel={processedLabel}
      status={status}
      successfulCount={process.successfulCount}
      title={process.title}
      totalItems={process.totalItems || process.totalCount}
      viewItemLabel={viewItemLabel}
    />
  })

  return (
    <div>
        { processing }
    </div>
  )
}

export default ProgressBar
